
__webpack_require__.remotesLoadingData = { chunkMapping: {"5645":["74363"]}, moduleIdToRemoteDataMapping: {"74363":{"shareScope":"default","name":"./remote","externalModuleId":53724,"remoteName":"@webtrader-chart"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
